export let heroAnimation = () => {
  
  let tl = gsap.timeline({
    defaults:{
      duration:0.8,
      delay:0.3,
      ease:'circ.in'
    }
  });
  let thisSection = $('.hero-section');
  let text = $('.hero-section-text');
  
  tl.to('.hero-section-overlay', {opacity:0},"heroIn");
  tl.to(text, {y:0, opacity:1, duration:0.6},'heroIn+=0.2');
}

export let whyExistAnimation = () => {
  
  let thisSection = $('.why-we-exist-section');
  let globe = $('.exist-globe-background img');
  
  gsap.set(globe, {scale:0.9, rotate:6});

  let tl = gsap.timeline({
    defaults:{
      duration:1.3,
      ease:'none'
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top bottom",
      end:"top top",
      scrub:true,
    }
  });
  tl.to(globe, {rotate:0, scale:1});
}

export let whereOperateAnimation = () => {
  
  let thisSection = $('.where-we-operate-section');
  
  let headline = $('.where-we-operate-intro').find('h2');
  let subheadline = $('.where-we-operate-intro').find('h5');
  let theBody = $('.where-we-operate-intro').find('p');
  let category = $('.operate-list-single-item');
  let mapKey = $('.single-map-key');
  let nextLink = $('.operate-next-section-link');
  let outline = $('.africaMapOutline');
  let mapFills = $('.africaMapBlueFills');
  let mapBorders = $('.africaMapCountryLines');
  let marker = $('.africaMapMarker');
  let hatches = $('.africaMapHatchLines');
  let oneHash = $(hatches).find('path');
  
  gsap.set([mapFills, mapBorders, oneHash, outline], {opacity:0});
  gsap.set(marker, {opacity:0, y:-4});

  gsap.set([headline, subheadline, theBody], {y:-0, opacity:0});
  gsap.set([category,mapKey, nextLink], {opacity:0});

  let tl = gsap.timeline({
    defaults:{
      duration:0.3,
      ease:'circ.out'
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center+=200",
      // toggleActions:'play reverse play reverse',
    },
    // onComplete: function(){
    //   repeatTL.play();
    // }
  });

  if ($(window).width() <= 767) {
    tl.to([subheadline, headline,theBody], {opacity:1, y:0, stagger:0.1},"p3Out+=0.2");
    tl.to(category, {opacity:1, y:0},"p3Out1-=0.2");
    tl.to(outline, {opacity:1}, "p3Out2");
    tl.to(mapBorders, {opacity:1}, "p3Out2+=0.2");
    tl.to(oneHash, {opacity:1, stagger:0.1}, "p3Out3+=0.3");
    tl.to(mapFills, {opacity:1}, "p3Out3+=0.3");
    tl.to([mapKey, nextLink], {opacity:1, stagger:0.1},"p3Out3+=0.5");
    tl.to(marker, {ease:'circ.out', opacity:1, y:0}, "p3Out3+=0.4");
  }
  else {  
    tl.to(outline, {opacity:1}, "p3Out");
    tl.to(mapBorders, {opacity:1}, "p3Out");
    tl.to(oneHash, {opacity:1, stagger:0.1}, "p3Out2");
    tl.to(mapFills, {opacity:1}, "p3Out2+=0.2");
    tl.to([subheadline, headline,theBody], {opacity:1, y:0, stagger:0.1},"p3Out3");
    tl.to(category, {opacity:1, y:0},"p3Out3+=0.3");
    tl.to(marker, {opacity:1, y:0}, "p3Out3");
    tl.to([mapKey, nextLink], {opacity:1, stagger:0.1},"p3Out4");
    
  }  
}

export let whatPovertyAnimation = () => {
  
  let thisSection = $('.what-is-energy-poverty-section');
  let overlay = $('.lightsOverlay');
  let headline = $('.energy-poverty-intro').find('h2');
  let subheadline = $('.energy-poverty-intro').find('h5');
  let theBody = $('.energy-poverty-intro').find('p');
  let category = $('.energy-poverty-intro').find('.section-vert-category');

  gsap.set([headline, subheadline, theBody], {y:-5, opacity:0});
  gsap.set(category, {y:-15, opacity:0});

  let tl = gsap.timeline({
    defaults:{
      duration:0.4,
      ease:'circ.out'
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center",
    },
    onComplete: function(){
      repeatTL.play();
    }
  });
  tl.to(overlay, {opacity:0, duration:0.5});
  tl.to([subheadline, headline,theBody], {opacity:1, y:0, stagger:0.1});
  tl.to(category, {opacity:1, y:0, stagger:0.1},'-=0.3');

  let repeatTL = gsap.timeline({
    paused:true,
    repeat:-1, 
    yoyo:true
  });
  repeatTL.to($(overlay), {duration:5, opacity:0.4, ease:'circ.inout'});

}

export let ourImpactAnimation = () => {
  
  let thisSection = $('.our-impact-section');
  let headline = $(thisSection).find('h2');
  let subheadline = $(thisSection).find('h5');
  let theBody = $(thisSection).find('p');
  let theButton = $(thisSection).find('.mission-button');

  // gsap.set([headline, subheadline, theBody,theButton], {y:-5, opacity:0});
  
  let tl = gsap.timeline({
    defaults:{
      duration:0.15,
      ease:'circ.in'
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "top center",
    },
    // onComplete: function(){
    //   repeatTL.play();
    // }
  });
  // tl.to(overlay, {opacity:0, duration:0.5});
  // tl.to([subheadline, headline,theBody,theButton], {opacity:1, y:0});
}

export let yourImpactAnimation = () => {
  
  let thisSection = $('.your-impact-images');
  let leftImg = $(".your-impact-left-image img");
  let rightImg = $(".your-impact-right-image img");
  let logo = $(".your-impact-logo");
  
  gsap.set([leftImg, rightImg, logo], {scale:1.05, opacity:0});

  let tl = gsap.timeline({
    defaults:{
      duration:0.3,
    },
    scrollTrigger: {
      trigger: thisSection,
      start: "center bottom",
      ease:'circ.in',
    }
  });
  tl.to(leftImg, {scale:1, opacity:1});
  tl.to(rightImg, {scale:1, opacity:1},"-=.15");
  tl.to(logo, {scale:1, opacity:1},"-=.15");
}
